import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Zap } from "lucide-react";

export default function AutomationCenter() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/success/automations");
    setItems(data.items || []);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (item) => {
    await api.put(`/success/automations/${item.key}`, { enabled: !item.enabled });
    toast.success(!item.enabled ? "Automation enabled" : "Automation disabled");
    load();
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-6">
        <div className="eyebrow mb-2">Success Center</div>
        <h1 className="font-display text-3xl font-bold text-navy">Automation Center</h1>
        <p className="text-sm text-slate-500 mt-1">Turn on/off recruiting automations. Save 8+ hours per week.</p>
      </div>

      <div className="space-y-3">
        {items.map(a => (
          <div key={a.key} className="border border-slate-200 rounded-xl bg-white p-5 flex items-start justify-between gap-4">
            <div className="flex items-start gap-3">
              <div className={`h-10 w-10 rounded-lg grid place-items-center flex-shrink-0 ${a.enabled ? "bg-gold/10 text-gold" : "bg-slate-100 text-slate-400"}`}>
                <Zap className="w-5 h-5" />
              </div>
              <div>
                <div className="font-display font-semibold text-navy">{a.label}</div>
                <div className="text-sm text-slate-500 mt-0.5">{a.description}</div>
              </div>
            </div>
            <button onClick={() => toggle(a)}
              className={`relative w-11 h-6 rounded-full transition-colors flex-shrink-0 ${a.enabled ? "bg-navy" : "bg-slate-200"}`}>
              <div className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all ${a.enabled ? "left-5" : "left-0.5"}`} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
